/**
 * PRIMUL HIMALAYAN THEME — primul-theme.js
 * Handles: scroll-aware nav, mobile menu, FAQ accordion,
 * testimonial slider, product image gallery, quantity selector
 */

(function () {
  'use strict';

  /* ── SCROLL-AWARE HEADER ── */
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run on load
  }

  /* ── MOBILE MENU ── */
  const toggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen.toString());
      mobileNav.setAttribute('aria-hidden', (!isOpen).toString());
      // Animate hamburger to X
      const lines = toggle.querySelectorAll('.hamburger-line');
      if (isOpen) {
        lines[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        lines[1].style.opacity = '0';
        lines[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        lines[0].style.transform = '';
        lines[1].style.opacity = '';
        lines[2].style.transform = '';
      }
    });
  }

  /* ── FAQ ACCORDION ── */
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach((item) => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!btn || !answer) return;

    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      // Close all others
      faqItems.forEach((other) => {
        const otherBtn = other.querySelector('.faq-question');
        const otherAnswer = other.querySelector('.faq-answer');
        if (otherBtn && otherAnswer && other !== item) {
          otherBtn.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
        }
      });
      // Toggle current
      btn.setAttribute('aria-expanded', (!isExpanded).toString());
      answer.hidden = isExpanded;
    });
  });

  /* ── TESTIMONIAL SLIDER ── */
  const slider = document.getElementById('testimonial-slider');
  const dotsContainer = document.getElementById('testimonial-dots');
  if (slider && dotsContainer) {
    const cards = slider.querySelectorAll('.testimonial-card');
    const dots = dotsContainer.querySelectorAll('.dot');
    let current = 0;
    let autoTimer;

    const showSlide = (index) => {
      cards.forEach((c, i) => c.classList.toggle('active', i === index));
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      current = index;
    };

    const next = () => showSlide((current + 1) % cards.length);

    const startAuto = () => {
      clearInterval(autoTimer);
      autoTimer = setInterval(next, 4500);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(parseInt(dot.dataset.index, 10));
        startAuto();
      });
    });

    startAuto();
  }

  /* ── PRODUCT IMAGE GALLERY ── */
  const thumbs = document.querySelectorAll('.product-thumb');
  const featuredImg = document.getElementById('product-featured-image');
  if (thumbs.length && featuredImg) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        featuredImg.src = thumb.dataset.src;
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── QUANTITY SELECTOR ── */
  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const input = selector.querySelector('.qty-input');
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });

    plus.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      input.value = val + 1;
    });
  });

  /* ── PRODUCT VARIANT SELECTOR ── */
  const optionBtns = document.querySelectorAll('.option-btn');
  const variantInput = document.querySelector('input[name="id"]');
  if (optionBtns.length && variantInput) {
    // Store variant data from Shopify (injected via meta tag or JSON)
    const variantData = window.__PRIMER_VARIANTS__ || [];

    optionBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const position = btn.dataset.optionPosition;
        // Deselect siblings
        document.querySelectorAll(`.option-btn[data-option-position="${position}"]`)
          .forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');

        // Find matching variant
        if (variantData.length) {
          const selected = {};
          document.querySelectorAll('.option-btn.active').forEach((b) => {
            selected[b.dataset.optionPosition] = b.dataset.value;
          });
          const match = variantData.find((v) =>
            Object.entries(selected).every(([pos, val]) => v[`option${pos}`] === val)
          );
          if (match) variantInput.value = match.id;
        }
      });
    });
  }

})();
